import { jsx as _jsx } from "react/jsx-runtime";
import UITag from 'UIComponents/tag/UITag';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as PlanType from 'ecosystem-marketplace-core/constants/pricings/PlanType';
import { getAssetBusinessTypeI18nKey, getAssetPageTypeI18nKey, getAssetPageFeatureI18nKey, getTierI18nKey // @ts-expect-error module is untyped
} from 'ecosystem-marketplace-core/utils/i18n'; // @ts-expect-error module is untyped

import MobileTagButton from 'ecosystem-marketplace-core/js/components/mobile/MobileTagButton';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';

function toFilterLabel({
  name,
  value
}) {
  let label;

  switch (name) {
    case ThemeQueryField.BUSINESS_TYPES:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.businessType.tag",
          options: {
            value: unescapedText(getAssetBusinessTypeI18nKey(value))
          }
        });
        break;
      }

    case ThemeQueryField.PAGE_TYPES:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.pageTypes.tag",
          options: {
            value: unescapedText(getAssetPageTypeI18nKey(value))
          }
        });
        break;
      }

    case ThemeQueryField.PAGE_FEATURES:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.pageFeatures.tag",
          options: {
            value: unescapedText(getAssetPageFeatureI18nKey(value))
          }
        });
        break;
      }

    case ThemeQueryField.PLAN_TYPE:
      {
        let tagValue;

        if (value === PlanType.FREE) {
          tagValue = unescapedText('marketplace-assets-ui.themes.filters.price.free');
        } else if (value === PlanType.ONE_TIME) {
          tagValue = unescapedText('marketplace-assets-ui.themes.filters.price.paid');
        } else {
          // TODO min/max price
          tagValue = unescapedText('marketplace-assets-ui.themes.filters.price.custom');
        }

        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.price.tag",
          options: {
            value: tagValue
          }
        });
        break;
      }

    case ThemeQueryField.PRICE_RANGE:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.price.tag",
          options: {
            value: unescapedText('marketplace-assets-ui.themes.filters.price.custom')
          }
        });
        break;
      }

    case ThemeQueryField.PORTAL_COMPATIBLE:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.portalCompatible.tag"
        });
        break;
      }

    case ThemeQueryField.TIERS:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.tiers.tag",
          options: {
            value: unescapedText(getTierI18nKey(value))
          }
        });
        break;
      }

    case ThemeQueryField.PROVIDERS:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.providers.tag",
          options: {
            value
          }
        });
        break;
      }

    case ThemeQueryField.MIN_OVERALL_RATING:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.rating.tag",
          options: {
            count: value
          }
        });
        break;
      }

    case ThemeQueryField.HAS_FREE_SUPPORT:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.support.tag"
        });
        break;
      }

    case ThemeQueryField.TAGS:
      {
        label = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.filters.searchTags.tag",
          options: {
            value
          }
        });
        break;
      }

    default:
      break;
  }

  return label;
}

function FilterTag({
  name,
  onClear,
  value
}) {
  return /*#__PURE__*/_jsx(UITag, {
    className: "m-left-0 m-right-2 m-y-1",
    closeable: true,
    inline: true,
    onCloseClick: () => onClear(name, value),
    children: toFilterLabel({
      name,
      value
    })
  });
}

export function MobileFilterTag({
  name,
  onClear,
  value
}) {
  return /*#__PURE__*/_jsx(MobileTagButton, {
    closeable: true,
    onClick: () => onClear(name, value),
    children: toFilterLabel({
      name,
      value
    })
  });
}
export default FilterTag;